import { styled } from 'baseui'

export const FullRow = styled('div', {
  gridColumn: '1 / -1',
})

export const MessagePanel = styled('div', ({ $theme }) => ({
  position: 'relative',
  backgroundColor: $theme.colors.white,
  borderRadius: $theme.borders.radius400,
  boxShadow: $theme.lighting.shadow400,
  borderLeftWidth: '6px',
  borderLeftStyle: 'solid',
  borderLeftColor: $theme.colors.primary,
  padding: '1.25rem 2rem 1rem 2rem',
  color: $theme.colors.textBody,
  ...$theme.typography.ParagraphMedium,
}))

export const MessagePanelHeader = styled('div', ({ $theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '1rem',
  paddingBottom: '0.75rem',
  marginBottom: '1rem',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: $theme.colors.borderLight,
  color: $theme.colors.primary,
  ...$theme.typography.HeadingSmall,
}))

export const MessagePanelContent = styled('div', {
  maxWidth: '80ch',
})

export const MessagePanelFooter = styled('div', ({ $theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '1.25rem',
  paddingTop: '0.75rem',
  borderTopWidth: '1px',
  borderTopStyle: 'solid',
  borderTopColor: $theme.colors.borderLight,
}))

export const closeButtonOverrides = {
  BaseButton: {
    style: ({ $theme }: { $theme: { colors: { bg050: string; primary: string; bg100: string } } }) => ({
      backgroundColor: $theme.colors.bg050,
      color: $theme.colors.primary,
      ':hover': { backgroundColor: $theme.colors.bg100 },
    }),
  },
}
